import moment from 'moment';
import renderHTML from 'react-render-html';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Spinner from '../../components/layout/Spinner';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { URI } from '../../domain/constant';
import {
  LINK_URL,
  PAGE_SINGLE_TITLE,
  PAGE_TITLE,
} from '../../shared/enums/activitys_enum';
import { useSingleActivity } from '../../shared/hooks/UseActivity';
import { useSelectAllProcess } from '../../shared/hooks/UseProcess';

const ViewActivity = ({ match, hideGallery }) => {
  const [data] = useSingleActivity(match.params.id);
  const { activity_loading, activity } = data;
  console.log('ACTIVITY', activity);

  const [process_data] = useSelectAllProcess();
  const { all_processs } = process_data;
  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={PAGE_SINGLE_TITLE}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='View'
        />
        {!activity_loading ? (
          activity && (
            <div className='container-fluid'>
              <div className='row'>
                <div className='col-lg-8'>
                  <div className='card'>
                    <div className='card-header'>
                      <div>
                        <h4 className='card-title'>
                          {activity.task_name}
                          <span>View</span>
                        </h4>
                        <p className='card-title-desc'>
                          <Link
                            to={`/activitys`}
                            className='btn btn-soft-light'
                          >
                            <i className='fa fa-angle-left'></i> Activity
                          </Link>

                          {
                            <Link
                              to={`/activitys/${activity._id}/edit`}
                              className='btn btn-soft-light'
                            >
                              <i className='fa fa-edit'></i>
                            </Link>
                          }
                        </p>
                      </div>
                    </div>
                    <div className='card-body py-4 px-3 bg-light'>
                      <div className='row g-3'>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Name
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.task_name}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Assigned To
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.assigned_to &&
                                activity.assigned_to.name}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Activity Cycle
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.activity_cycle &&
                                activity.activity_cycle._id}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Due Time
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {moment(activity.due_time).format(
                                'MM/DD/YYYY h:mm:ss a'
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Client Name
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.client && activity.client.name}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Process
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.process && activity.process.name}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Estimate Time
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.estimated_time &&
                                activity.estimated_time}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Actual Time
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.actual_time && activity.actual_time}
                            </div>
                          </div>
                        </div>
                        <div className='col-12'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Task Description
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.task_description &&
                                renderHTML(activity.task_description)}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Attachment
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.attachments &&
                                activity.attachments.map((item, i) =>
                                  !hideGallery ? (
                                    <a
                                      key={i}
                                      href={`${URI}${item.image}`}
                                      target={'_blank'}
                                      rel='noopener noreferrer'
                                      className='text-primary fw-bold me-2'
                                    >
                                      View
                                    </a>
                                  ) : null
                                )}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Review Status
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.review_status &&
                                activity.review_status.name}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Activity Status
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.activity_status &&
                                activity.activity_status.name}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Comment
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.comment && activity.comment}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Created By
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {activity.created_by && activity.created_by.name}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Created At
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {moment(activity.createdAt).format(
                                'MM/DD/YYYY h:mm:ss a'
                              )}
                            </div>
                          </div>
                        </div>
                        <div className='col-md-6'>
                          <div className='border rounded-3 p-3 bg-white h-100 d-flex flex-column justify-content-between shadow-sm'>
                            <div className='text-uppercase text-secondary small fw-bold mb-1'>
                              Updated At
                            </div>
                            <div className='fw-semibold fs-6 text-dark'>
                              {moment(activity.updatedAt).format(
                                'MM/DD/YYYY h:mm:ss a'
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-4'>
                  <div className='card'>
                    <div className='card-header'>
                      <div className='card-title-side'>
                        <h4>Checklist:</h4>
                      </div>
                    </div>
                    <div className='card-body'>
                      <div className='card-body-single-data'>
                        <div className='card-body-received-datalist'>
                          {activity.checklist &&
                            activity.checklist.map((item, index) => {
                              return (
                                <div className='card-body-received-data'>
                                  <div className='checklist-data-content'>
                                    {item && item.is_checked ? (
                                      <div className='d-flex'>
                                        <div className='checklist-data-list-img'>
                                          <input
                                            type='checkbox'
                                            checked
                                            disabled
                                          />
                                        </div>
                                        <div className='checklist-data-content'>
                                          {renderHTML(item.name)}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className='d-flex'>
                                        <div className='checklist-data-list-img'>
                                          <input type='checkbox' disabled />
                                        </div>
                                        <div className='checklist-data-content'>
                                          {renderHTML(item.name)}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='card'>
                    <div className='card-header'>
                      <div className='card-title-side'>
                        <h4>SOP:</h4>
                        <p>Standard Operating Procedure</p>
                      </div>
                    </div>
                    <div className='card-body'>
                      <div className='card-body-single-data'>
                        <div className='card-body-received-datalist'>
                          {activity.process &&
                            activity.process.sop &&
                            activity.process.sop.map((item) => {
                              return (
                                <div className='card-body-received-data d-flex pb-3'>
                                  <div className='checklist-data-list-img'>
                                    <img src='/images/sop_3.png' alt='' />
                                  </div>
                                  <div className='checklist-data-content'>
                                    {renderHTML(item.name)}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewActivity;
<style>{`
  .card-body-sleek {
    padding: 18px 22px 12px 22px;
    background: #f7fafd;
    border-radius: 0 0 12px 12px;
    box-shadow: 0 2px 8px rgba(24,119,242,0.04);
  }
  .row-sleek {
    margin-left: -8px;
    margin-right: -8px;
  }
  .sleek-field {
    margin-bottom: 16px !important;
    padding-left: 8px;
    padding-right: 8px;
    background: #fff;
    border-radius: 7px;
    box-shadow: 0 1px 4px rgba(24,119,242,0.06);
    border: 1px solid #e4e6ea;
    padding: 10px 14px 8px 14px;
    transition: box-shadow 0.2s;
  }
  .sleek-field:hover {
    box-shadow: 0 4px 16px rgba(24,119,242,0.10);
    border-color: #b6d4fe;
  }
  .sleek-title {
    font-size: 12px;
    color: #6c757d;
    font-weight: 700;
    margin-bottom: 3px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }
  .sleek-value {
    font-size: 15px;
    color: #222;
    font-weight: 500;
    word-break: break-word;
    padding: 2px 0 0 0;
    min-height: 22px;
    display: flex;
    align-items: center;
    line-height: 1.5;
  }
  .sleek-value a {
    color: #1877f2;
    text-decoration: underline;
    font-size: 14px;
    margin-right: 8px;
  }
`}</style>;
